import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, Home, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import Seo from '../components/Seo';

const NotFoundPage = () => {
  // Array of funny 404 messages
  const funnyMessages = [
    "Oops! This photo seems to have wandered off into the sunset...",
    "404: Photo not found. Even our best lens couldn't spot this page!",
    "Looks like this shot was out of focus. Page not found!",
    "This page went on vacation to Mauritius and never came back.",
    "Error 404: We looked through all our filters, but this page doesn't exist.",
    "Hmm, this page is more elusive than the perfect golden hour shot!"
  ];
  
  // Pick a random message
  const randomMessage = funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <Seo title="Page Not Found" noindex />
      <div className="text-center max-w-lg">
        {/* 404 Icon */}
        <div className="relative mb-8">
          <div className="text-9xl font-bold text-gray-200">404</div>
          <Camera className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-20 h-20 text-gray-400" />
        </div>

        {/* Funny Message */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h1>
        <p className="text-gray-600 mb-8">{randomMessage}</p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/">
            <Button className="flex items-center space-x-2">
              <Home className="w-4 h-4" />
              <span>Back to Home</span>
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="flex items-center space-x-2" data-testid="notfound-contact-btn">
              <Mail className="w-4 h-4" />
              <span>Contact</span>
            </Button>
          </Link>
        </div>

        {/* Decorative element */}
        <div className="mt-12 text-gray-300">
          <p className="text-sm">Meanwhile, enjoy some beautiful photos on our homepage!</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
